import React from 'react';

function LabelIcon() {
  return (
    <svg width="52" height="80" viewBox="0 0 52 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00098 76.0208V47.7815H12.5524L0.140625 37.7815V70.1642L6.00098 76.0208ZM13.5867 79.7815C14.732 79.9325 15.8933 79.9325 17.0385 79.7815H13.5867Z"
        fill="#BF1E24"
      />
      <g filter="url(#filter0_i_340_47766)">
        <path
          d="M29.0476 3.84503C34.1743 -1.28167 42.4863 -1.28168 47.613 3.84502C52.7397 8.97173 52.7397 17.2837 47.613 22.4104L0.138672 69.8848V35.2363C0.138672 33.6449 0.770901 32.1187 1.89626 30.9934L29.0476 3.84503Z"
          fill="url(#paint0_linear_340_47766)"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_340_47766"
          x="0.138672"
          y="0"
          width="51.3184"
          height="70.8848"
          filterUnits="userSpaceOnUse"
          colorIterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_340_47766" />
        </filter>
        <linearGradient
          id="paint0_linear_340_47766"
          x1="25.7983"
          y1="0"
          x2="25.7983"
          y2="69.8848"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FB5764" />
          <stop offset="1" stopColor="#FA842E" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default LabelIcon;
